module.exports = __webpack_public_path__ + "img/stroke-1-copy.e4678916.svg";